<template>
    <div>
        <app-select
            label="Hintergrund- und Schriftfarbe"
            :data-source="'tecpage.user.modules.' + moduleId + '.appearance.color'"
            :options="getActiveModuleAppearanceColors"
            :data-default="{ type: 'random' }"
            :custom-class="'appearance-color'"
            hide-clear
            required
        ></app-select>

        <app-checkbox
            label="Hintergrundbild"
            :data-source="'tecpage.user.modules.' + moduleId + '.appearance.background.active'"
        ></app-checkbox>

        <app-filepicker
            v-show="
                getProp('tecpage.user.modules.' + moduleId + '.appearance.background.active') == 1
            "
            :required="
                getProp('tecpage.user.modules.' + moduleId + '.appearance.background.active') == 1
            "
            revalidate-target="background"
            label="Hintergrundbild"
            :data-source="'tecpage.user.modules.' + moduleId + '.appearance.background.image'"
            accept=".jpg,.png,.gif"
            :show-focus="true"
            :show-transparency="true"
            :transparency-default="85"
        ></app-filepicker>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Text from '@/components/fields/simple/Text.vue';
import Select from '@/components/fields/simple/Select.vue';
import Checkbox from '@/components/fields/simple/Checkbox.vue';
import Filepicker from '@/components/fields/complex/Filepicker.vue';

export default {
    data() {
        return {};
    },
    methods: {},
    computed: {
        ...mapGetters(['getProp', 'getActiveModuleAppearanceColors'])
    },
    mounted() {
        this.$emit('controlhead', {
            title: this.$helpers.uiText('R013'),
            help: this.$helpers.uiText('R014'),
            removeText: this.$helpers.uiText('R026'),
            showGlobal: false
        });
    },
    props: {
        moduleId: String
    },
    components: {
        'app-text': Text,
        'app-select': Select,
        'app-checkbox': Checkbox,
        'app-filepicker': Filepicker
    }
};
</script>
